module.exports = __webpack_public_path__ + "media/星地光谱数据获取分析应用.fbc2e22a.mp4";